module.exports = __webpack_public_path__ + "static/media/bye4.9e3f6563.gif";